module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8n3r6r-16f4273ee94e1806fe4482d57a9aade2.svg";